import { useContext, useState } from 'react';

// Styles
import { SubmitMeterHealthWrapper } from './SubmitMeterHealth.styles';

import { Health, IHealthCheck } from '../Health/Health';
import { UserDetailContext, UserDetailContextProps } from '../../../context/userDetail/userDetailContext';
import { useFetchHealthChecks } from '../hooks/useFetchHealthChecks';
import { useHistory } from 'react-router-dom';
import { SearchDetailContext, SearchDetailContextProps } from '../../../context/searchDetail/searchDetailContext';
import { RoutingToTypes } from '../../search/SearchActions/SearchActions';
import { ModalTemplate } from '../../mymessages/modalTemplates/ModalTemplate';
import { HealthWidget } from '../HealthWidget/HealthWidget';

type SubmitMeterHealthProps = {
  status: 'loading' | 'healthy' | 'notHealthy';
  resetHealthCheck: Function;
};

const defaultProps = {
  status: 'loading',
};

export const SubmitMeterHealth = (props: SubmitMeterHealthProps) => {
  const searchContext = useContext<SearchDetailContextProps>(SearchDetailContext);
  const history = useHistory();

  const { userDetail, setUserDetail } = useContext<UserDetailContextProps>(UserDetailContext);

  const [showModal, setShowModal] = useState<boolean>(false);
  const [messagevalues, setMessageValues] = useState<Messages.IMessagesValues>();

  const hc: Array<IHealthCheck> = [];

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const onMoreInfoClick = (healthCheck: IHealthCheck) => {
    if (!healthCheck.response) return;

    history.push(healthCheck.route);
  };

  const { healthChecks } = useFetchHealthChecks(hc, userDetail.customerAccounts, props.status);

  return (
    <SubmitMeterHealthWrapper>
      <HealthWidget
        widgetKey='SubmitMeter'
        title='Submit meter reading'
        type='SubmitMeterReading'
        healthChecks={healthChecks}
        checkingText='Checking...'
        healthyText=''
        customers={userDetail.customerAccounts} // TODO WILL NEED TPIREFERENCE ?
        onMoreInfoClick={onMoreInfoClick}
        resetHealthCheck={props.resetHealthCheck}
      ></HealthWidget>

      <ModalTemplate
        name={'HealthCheckModal'}
        messagevalues={messagevalues}
        show={showModal}
        onHide={handleCloseModal}
      />
    </SubmitMeterHealthWrapper>
  );
};

SubmitMeterHealth.defaultProps = defaultProps;
